import {LMFSAccessor, NativeMeshInteractor} from "@amzn/dolphin-web-framework";
import { getCurrentCycle } from "@amzn/dolphin-uiweb-framework";
import {getRegion, getStage} from "../../utils/network/BaseUrlUtils";
import {REDIRECT_FROM_MODULE} from "./Constants";

async function getConsentStatus(module, setConsentStatus, setExperimentStatus = null) {
    const data = await LMFSAccessor.fetchUpdateConsentStatus(getStage(), getRegion(), LMFSAccessor.CONSENT_REQUEST_TYPES.FETCH,
        getConsentType(module), false);
    if (data && data.result) {
        setConsentStatus(data.result);
    }
    if (setExperimentStatus && data && data.experimentStatus) {
        setExperimentStatus(data.experimentStatus);
    }
}

async function updateConsentStatus(module, isConsented, setConsentStatus) {
    const data = await LMFSAccessor.fetchUpdateConsentStatus(getStage(), getRegion(), LMFSAccessor.CONSENT_REQUEST_TYPES.UPDATE,
        getConsentType(module), isConsented);
    if (data && data.result) {
        setConsentStatus(data.result);
    }
}

async function getAssociatesData(setData, cycle) {
    // Use CycleSelector's internal storage if no cycle provided
    const data = await LMFSAccessor.fetchSVSAssociatesData(getStage(), getRegion(), cycle || getCurrentCycle());
    if (data) {
        console.log('Got response from SVS:', data);
        setData(data);
    } else {
        console.log('No data received from SVS, using default values');
        setData({
            associateStowMetrics: {
                pph: 0,
                fsaf: 0,
                stowedCount: 0
            },
            stationStowMetrics: {
                pph: 0,
                fsaf: 0,
                stowedCount: 0
            }
        });
    }
}

function isRedirectFromModuleValid(module) {
    return module === REDIRECT_FROM_MODULE.STOW;
}

function getConsentType(module) {
    if (module === REDIRECT_FROM_MODULE.STOW) {
        return LMFSAccessor.CONSENT_TYPE.STOW_SUMMARY;
    }
    
    const validConsentTypes = Object.values(LMFSAccessor.CONSENT_TYPE);
    if (validConsentTypes.includes(module)) {
        return module;
    }
    
    return null;
}

const exitModule = () => {
    NativeMeshInteractor.exitModule();
}

function getNumericalDisplayValueFromData(value) {
    if (typeof value === 'number') {
        return Math.round(value);
    }
    return 'N/A';
}

export {
    getConsentStatus,
    updateConsentStatus,
    isRedirectFromModuleValid,
    getAssociatesData,
    exitModule,
    getNumericalDisplayValueFromData
}
